import type {AgentBuilderActions} from 'src/action-creators/agent-builder';
import type {
  AgentConfig,
  ChannelSettings,
  AgentStreamData,
  AgentReminderRules,
} from 'src/types/agent-builder';

import {
  RECEIVE_CHANNEL_SETTINGS,
  RECEIVE_AGENT_SUGGESTION,
  RECEIVE_AGENT_STREAM_DATA,
  RECEIVE_AGENT_CONFIGURATION,
  RECEIVE_AGENT_BUILDING,
  RECEIVE_AGENT_REMINDER,
} from 'src/action-creators/agent-builder';


interface AgentBuilderState {
  suggestion: string | null;
  streamData: Partial<AgentStreamData> | null;
  selectedAgent: AgentConfig | null;
  channelSettings: ChannelSettings | null;
  isAgentBuilding: boolean;
  agentReminder: AgentReminderRules | null;
}

const initialState: AgentBuilderState = {
  suggestion: null,
  streamData: null,
  selectedAgent: null,
  channelSettings: null,
  isAgentBuilding: false,
  agentReminder: null,
};

export default (
  state: AgentBuilderState = initialState,
  action: AgentBuilderActions,
): AgentBuilderState => {
  switch (action.type) {
    case RECEIVE_CHANNEL_SETTINGS:
      return {
        ...state,
        channelSettings: action.payload,
      };
    case RECEIVE_AGENT_SUGGESTION:
      return {
        ...state,
        suggestion: action.payload,
      };
    case RECEIVE_AGENT_CONFIGURATION:
      return {
        ...state,
        selectedAgent: action.payload
          ? {
              ...(state.selectedAgent || {}),
              ...action.payload,
            }
          : action.payload,
      };
    case RECEIVE_AGENT_STREAM_DATA:
      return {
        ...state,
        streamData: {
          ...(state.streamData || {}),
          ...action.payload,
        },
      };
    case RECEIVE_AGENT_BUILDING:
      return {
        ...state,
        isAgentBuilding: action.payload,
      };
    case RECEIVE_AGENT_REMINDER:
      return {
        ...state,
        agentReminder: action.payload,
      };
    default:
      return state;
  }
};
